import type { AppProps } from 'next/app';

import { Edge } from '@/components/Edge';
import { StateProviders } from '@/components/StateProviders';
import { initAllerUserConsentQueue } from '@/utils/initAllerUserConsentQueue';
import { withComponentsRenderDebug } from '@/utils/withComponentsRenderDebug';
import { withCookiesInterceptor } from '@/utils/withCookiesInterceptor';
import { withDevelopmentConsentCookie } from '@/utils/withDevelopmentConsentCookie';
import { withFetchInterceptor } from '@/utils/withFetchInterceptor';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { GridOverlay } from 'base/components/GridOverlay';
import { with410 } from 'base/with410';
import '../base/css/styles.css';

withComponentsRenderDebug();
withCookiesInterceptor();
withDevelopmentConsentCookie();
withFetchInterceptor();

function MyApp({ Component, pageProps }: AppProps) {
  initAllerUserConsentQueue();

  return (
    <ErrorBoundary>
      <StateProviders {...pageProps}>
        <GridOverlay />

        <Edge>{with410(<Component {...pageProps} />, pageProps)}</Edge>
      </StateProviders>
    </ErrorBoundary>
  );
}

export default MyApp;
